// extracted by mini-css-extract-plugin
module.exports = {"container":"PostContent_container__6gFp5","codeBlock":"PostContent_codeBlock__7V9dN","thumbnail":"PostContent_thumbnail__OZGAh","list":"PostContent_list__n_ej6"};